// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eebdfc73","488":"93547b99","667":"e208ec75"}[chunkId] + ".chunk.js";
};